<template>
	<div v-if="footer">
		<a v-for="media in contactInfo" :key="media.id" :href="media.value" target="_blank" rel="noopener noreferrer">
			<v-btn icon>
				<v-icon color="primary">{{ media.icon }}</v-icon>
			</v-btn>
		</a>
	</div>

	<v-card v-else>
		<v-card-text class="text-center pb-0">
			<h2>تواصل معنا</h2>
		</v-card-text>
		<v-card-text class="text-center">
			<a v-for="media in contactInfo" :key="media.id" :href="media.value" target="_blank" rel="noopener noreferrer">
				<v-btn icon>
					<v-icon>{{ media.icon }}</v-icon>
				</v-btn>
			</a>
		</v-card-text>
	</v-card>
</template>

<script>
export default {
	props: {
		footer: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		contactInfo() {
			return this.$store.state.contactInfo;
		}
	}
};
</script>